import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const Integrations = props => (
    <SvgIcon {...props}>
        <path
            fillRule="evenodd"
            stroke="none"
            d="M10.444.62l2.458 2.457-2.458 2.458L9.9 4.99 8.08 9.314l.692.693 4.442-1.702-.449-.45 2.458-2.457.777.778v3.36l-.777.777-.544-.544-1.82 4.324 1.544 1.545-.358.359H9.847l-.358-.36 2.457-2.457.544.544 1.82-4.323-.722-.723-4.442 1.702.48.48-2.458 2.457-2.458-2.458 2.458-2.457.543.544 1.82-4.324-.653-.654L4.436 5.67l.479.48-2.458 2.457L0 6.149l2.457-2.457 1.605 1.604 4.442-1.702-.517-.517z"
        />
    </SvgIcon>
);

export default Integrations;
